import * as React from "react";
import "../Styles/style.css";
import { useHistory } from "react-router-dom";
import useFetchMake from "../../customHooks/useFetchMake";
import { baseUrl, awsImageURL } from "../../api/ipconfig";
import { Grid, useMediaQuery } from "@mui/material";
import Slider from "react-slick";

export default function Manufactures() {
  const { make, error } = useFetchMake(baseUrl);
  const [showAll, setShowAll] = React.useState(false);
  const history = useHistory();
  const buttonRef = React.useRef(null);

  const openByMake = (makeName) => {
    history.push(`/search?make=${makeName}&`);
  };

  const handleShowToggle = () => {
    setShowAll(!showAll);

    // Scroll button into view smoothly
    setTimeout(() => {
      buttonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 0);
  };

  const limitedMake = showAll ? make : make?.slice(0, 14);

  const isMobile = useMediaQuery("(max-width: 1024px)");

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <div className="bg_dark ">
      <div className="container  mt-5 pb-3">
        <h2 className="section-titles">Browse Cars by Make</h2>
        <div className="row g-1">
          {!isMobile ? (
            <Grid container>
              {limitedMake &&
                limitedMake.map((item) => (
                  <div
                    className="custom-col-7 mb-3"
                    style={{
                      padding: "5px",
                      // border: "1px solid #ddd",
                      margin: "0 auto",
                    }}
                    key={item?.makeId}
                    onClick={() => openByMake(item?.makeName)}
                  >
                    <div
                      className="shadow-card text-center"
                      style={{
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        border: "1px solid #ddd",
                      }}
                    >
                      <div
                        style={{
                          height: "100px",
                          overflow: "hidden",
                          padding: "5px",
                        }}
                      >
                        <img
                          width={100}
                          height={100}
                          src={`${awsImageURL}/makes/${item?.makeImage}`}
                          alt={item?.makeName}
                          className="card-img-top"
                          style={{
                            objectFit: "contain",
                            height: "60px",
                            maxWidth: "100%",
                          }}
                        />
                      </div>
                      <p
                        className="mt-2 text-capitalize"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        {item?.makeName}
                      </p>
                    </div>
                  </div>
                ))}
            </Grid>
          ) : (
            <div className="container ">
              <Slider {...sliderSettings}>
                {limitedMake &&
                  limitedMake.map((item) => (
                    <div
                      className="custom-col-7 mb-3"
                      style={{
                        padding: "5px",
                        // border: "1px solid #ddd",
                        margin: "0 auto",
                      }}
                      key={item?.makeId}
                      onClick={() => openByMake(item?.makeName)}
                    >
                      <div
                        className="shadow-card text-center"
                        style={{
                          padding: "10px",
                          width: "100%",
                          backgroundColor: "#fff",
                          cursor: "pointer",
                          border: "1px solid #ddd",
                        }}
                      >
                        <div
                          style={{
                            height: "90px",
                            overflow: "hidden",
                            padding: "5px",
                          }}
                        >
                          <img
                            width={100}
                            height={100}
                            src={`${awsImageURL}/makes/${item?.makeImage}`}
                            alt={item?.makeName}
                            className="card-img-top"
                            style={{
                              objectFit: "contain",
                              height: "60px",
                              maxWidth: "100%",
                            }}
                          />
                        </div>
                        <p
                          className=" text-capitalize"
                          style={{ fontSize: "12px", fontWeight: "500" }}
                        >
                          {item?.makeName}
                        </p>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          )}
        </div>

        {/* Show More / Show Less Button */}
        {make?.length > 12 && (
          <div className="text-center d-flex justify-content-end mx-2 mt-4">
            <button
              className="more-btn"
              onClick={handleShowToggle}
              ref={buttonRef}
            >
              {showAll ? "Show Less" : "Show More"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
